import { createAction, props } from '@ngrx/store';
import { supportTicketsListPayload, supportTicketsDetailPayload, supportTicketsReplaysPayload } from './support-tickets.model'

export const fetchSupportTicketsList = createAction('[Data] Fetch Support Tickets List', props<{ payload: supportTicketsListPayload }>());
export const fetchSupportTicketsListSuccess = createAction('[Data] Fetch Support Tickets List Success', props<{ response: any }>());
export const fetchSupportTicketsListFailure = createAction('[Data] Fetch Support Tickets List Failure', props<{ error: string }>());

export const fetchSupportTicketsDetail = createAction('[Data] Fetch Support Tickets Detail', props<{ payload: supportTicketsDetailPayload }>());
export const fetchSupportTicketsDetailSuccess = createAction('[Data] Fetch Support Tickets Detail Success', props<{ response: any }>());
export const fetchSupportTicketsDetailFailure = createAction('[Data] Fetch Support Tickets Detail Failure', props<{ error: string }>());

export const assignAgentTicket = createAction('[Data] Assign Agent Ticket', props<{ payload: any }>());
export const assignAgentTicketSuccess = createAction('[Data] Assign Agent Ticket Success', props<{ response: any }>());
export const assignAgentTicketFailure = createAction('[Data] Assign Agent Ticket Failure', props<{ error: string }>());

export const updateTicketStatus = createAction('[Data] Update Ticket Status', props<{ payload: any }>());
export const updateTicketStatusSuccess = createAction('[Data] Update Ticket Status Success', props<{ response: any }>());
export const updateTicketStatusFailure = createAction('[Data] Update Ticket Status Failure', props<{ error: string }>());

export const ticketCards = createAction('[Data] Ticket Cards');
export const ticketCardsSuccess = createAction('[Data] Ticket Cards Success', props<{ response: any }>());
export const ticketCardsFailure = createAction('[Data] Ticket Cards Failure', props<{ error: string }>());

export const fetchSupportTicketsReplays = createAction('[Data] Fetch Support Tickets Replays', props<{ ticketId: supportTicketsReplaysPayload }>());
export const fetchSupportTicketsReplaysSuccess = createAction('[Data] Fetch Support Tickets Replays Success', props<{ response: any }>());
export const fetchSupportTicketsReplaysFailure = createAction('[Data] Fetch Support Tickets Replays Failure', props<{ error: string }>());

export const sendSupportTicketReply = createAction(
  '[Data] Send Support Ticket Reply',
  props<{ formData: FormData }>()
);
export const sendSupportTicketReplySuccess = createAction(
  '[Data] Send Support Ticket Reply Success',
  props<{ response: any }>()
);
export const sendSupportTicketReplyFailure = createAction(
  '[Data] Send Support Ticket Reply Failure',
  props<{ error: string }>()
);
